module.exports = __webpack_public_path__ + "static/media/nexus.3e3b5dc1.svg";